import moment from "moment";
import { Icon } from "@iconify/react";
import { IconButton, Tooltip } from "@mui/material";
import "./TicketLog.css";

const TicketLog = ({
  data,
  setTicketAction,
  setSelectedTicket,
  contactDetailData,
}) => {
  const renderStatus = (id) => {
    let icon;
    let description;

    switch (id) {
      case 1:
        icon = "mdi:close-box-outline";
        description = "Closed";
        break;

      case 2:
        icon = "mdi:information-box-outline";
        description = "New";
        break;

      case 3:
        icon = "mdi:progress-clock";
        description = "In Progress";
        break;

      default:
        break;
    }

    return (
      <>
        <Icon icon={icon} width="18" height="18" />
        <p>{description}</p>
      </>
    );
  };

  return (
    <div className="ticket-log">
      {process.env.NODE_ENV === "development" &&
        console.log(
          "dataTicketLog:",
          data,
          "dataContactDetail:",
          contactDetailData
        )}

      {data.length === 0 ? (
        <p className="no-ticket">No Ticket Found</p>
      ) : (
        <div className="timeline">
          {data?.map((log) => {
            return (
              <div
                className="item-container"
                key={log.TicketID}
                onClick={() => {
                  setTicketAction("edit");
                  setSelectedTicket(log.TicketID);
                }}
              >
                <Icon
                  color="#727272"
                  icon={(() => {
                    switch (log.ContactID) {
                      case 1:
                        return "mdi:phone"; // Phone
                      case 2:
                        return "material-symbols:mail-outline-rounded"; // Email
                      case 3:
                        return "material-symbols:fax-outline-rounded"; // Fax
                      case 5:
                        return "material-symbols:chat-outline"; // Chat
                      case 6:
                        return "mdi:twitter"; // Twitter
                      case 7:
                        return "ic:baseline-facebook"; // Facebook
                      case 8:
                        return "mdi:instagram"; // Instagram
                      case 9:
                        return "ic:baseline-whatsapp"; //Whatsapp
                      case 18:
                        return "fluent:video-person-call-24-filled"; // In-app Video Call
                      default:
                        break;
                    }
                  })()}
                  width="26"
                  height="26"
                />

                <div className="item">
                  <div className="data">
                    <p className="titleTicketLog">{log.Title}</p>
                    <p>Created by {log.CreatedUser}</p>
                    <p>Department: {log.Department}</p>
                    <p>{log.TicketNo}</p>
                  </div>

                  <div className="time-status">
                    {log.LastUpdateUser ? (
                      <p>Update by {log.LastUpdateUser}</p>
                    ) : (
                      ""
                    )}

                    <p>
                      {moment.utc(log.CreatedDate).format("DD MMM YYYY HH:mm")}
                    </p>

                    <div className="status">{renderStatus(log.StatusID)}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Tooltip arrow title="Create ticket">
        <IconButton
          className="create-ticket-button"
          onClick={() => setTicketAction("create")}
        >
          <Icon icon="ic:round-add" width="34" height="34" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default TicketLog;
